<template>
  <div>
    <!-- section welcome -->
    <section class="section_welcome" id="section_welcome">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-sm-offset-3 col-md-12">
            <div class="welcome_content">
              <img
                src="@/assets/logo_dafni_02.png"
                alt="Restaurant Dafni Logo"
                class="logo-main"
              />
            </div>
            <!-- .welcome_content -->
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
      <div class="welcome-video_bg">
        <video ref="video-home" autoplay muted loop preload="auto" playsinline>
          <source src="assets/video/video_bg_meer.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="video-sound-toggle" @click="toggleVideoSound">
        <img
          src="@/assets/volume_off.svg"
          alt="Video Ton aus"
          width="28"
          height="28"
          v-if="this.videoMuted"
        />
        <img
          src="@/assets/volume_on.svg"
          alt="Video Ton an"
          width="28"
          height="28"
          v-else
        />
      </div>
    </section>
    <!-- section about -->
    <section class="section_about" id="section_about">
      <div class="container">
        <!-- Urlaub -->
        <!--
        <div class="row">
          <div class="col-sm-offset-4 col-sm-4">
            <p>
              Liebe Gäste,<br />
              wir machen vom 14.07.2025 bis zum 13.08.2025 Betriebsurlaub.<br />
              <br />
              Ihr Dafni Team
            </p>
          </div>
        </div>
        -->
        <!-- Öffnungszeiten -->
        <!--
        <div class="row">
          <div class="col-sm-12 text-center">
            <h2 class="h2 c-text-color">
              <span>Neue Öffnungszeiten!</span>
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-offset-4 col-sm-4">
            <p>
              <b>Öffnungszeiten:</b><br />
              Mo-So: 11:30 - 14:30 Uhr und 17:30 - 24:00 Uhr.
            </p>
          </div>
        </div>
        -->
        <!-- .row -->
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h1 class="section_title h2">
              <span>Restaurant Dafni</span>
            </h1>
            <hr class="section_title_line" />
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
      <div class="section_about__row">
        <div class="about_desc">
          <h2 class="about_desc__title">In Aurich seit 1981</h2>
          <p class="about_desc__text">
            Das griechische Restaurant mitten in Aurich. Als Familienbetrieb
            bieten wir unseren Gästen im Restaurant Dafni eine gemütliche
            Atmosphäre im Herzen der Stadt Aurich.
          </p>
        </div>
        <div class="about_desc">
          <h2 class="about_desc__title">Griechische Spezialitäten</h2>
          <p class="about_desc__text">
            Eine große Auswahl an griechischen Gerichten, von Bifteki über Giros
            bis zum herzhaften Moussaka. Werfen Sie einen Blick auf unsere
            Speisekarte und entdecken Sie unsere köstlichen griechischen
            Spezialitäten.
          </p>
        </div>
      </div>
      <!-- .section_about__row -->
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  metaInfo: {
    title: "Restaurant Dafni Aurich"
  },
  components: {},
  data() {
    return {
      videoMuted: true
    };
  },
  methods: {
    toggleVideoSound() {
      this.videoMuted = !this.videoMuted;
      const video = this.$refs["video-home"];
      video.muted = this.videoMuted;
      video.volume = 0.2;
    }
  }
};
</script>

<style lang="scss">
.c-text-color {
  color: #1b2d2f;
}

.section_welcome {
  & .logo-main {
    width: 100%;
    max-width: 400px;
  }

  .video-sound-toggle {
    position: absolute;
    right: 20px;
    top: 80px;
    z-index: 500;
    cursor: pointer;
    color: #ffffff;

    .img {
      color: #ffffff;
    }
  }
}

.section_about .section_title:before {
  content: "";
}

.section_about .section_about__row .about_desc__title {
  //font-size: 24px;
  font-size: 1.5em;
}

.section_about .section_about__row .about_desc__text {
  font-size: 16px;
}

.section_about .section_about__row .about_desc__text:first-letter {
  font-size: inherit;
  color: inherit;
}

.section_about .section_about__row:last-child {
  margin-bottom: 40px;
}
</style>
